export enum ProcessProviderId {
  All = -1,
  FortressGB = 0,
  UniqueCode = 1,
  Download = 2,
  Event = 3,
  Product = 4,
  VirtualEvent = 5,
}

export enum FeaturesRewardsItem {
  ALL = 'all',
  Marketplace = 'marketplace',
  Events = 'events',
  Auctions = 'auction',
  Lottos = 'lotto',
}

export const marketplaceIdArr = [0, 1, 2, 4];
